import React from "react";
import {FlexCol, BaseGrid} from "../generic/Containers";
import {BCHeader2, Body1} from "../generic/BCHeaders";
import NotSureWhenIcon from "../../images/painpoints/not-sure-when.svg";
import MessUpInterviewsIcon from "../../images/painpoints/mess-up-interviews.svg";
import HeardNothingIcon from "../../images/painpoints/heard-nothing.svg";
import WeakResumeIcon from "../../images/painpoints/weak-resume.svg";


const painPoints: Array<{ label: string; img: string }> = [
    {label: 'Applied to 100+ jobs, heard nothing back', img: HeardNothingIcon},
    {label: 'My resume feels weak and generic', img: WeakResumeIcon},
    {label: 'Not sure when "Im Read" to apply', img: NotSureWhenIcon},
    {label: 'Afraid I\'ll mess up interviews', img: MessUpInterviewsIcon},
];

export const PainPointsComponent: React.FC = () => {
    return (
        <FlexCol
            widthPercent={100}
            align="center"
            pVertical={2}
            pHorizontal={2}
            style={{
                backgroundColor: '#EBF4FC',
            }}
        >
            <BCHeader2 
                text={"Sound familiar? You're in the right place."} 
                textAlign="center"
                mBottom={.6}
                className="landing-section-header"
            />
            <BaseGrid 
                columns={4}
                mobileColumns={1}
                tabletColumns={1}
                gap={1.5}
                pVertical={1}
                maxWidthEMs={70}
            >
                {painPoints.map((item, index) => (
                    <PainPointCard key={index} icon={item.img} label={item.label} />
                ))}
            </BaseGrid>
        </FlexCol>
    )
}

export const PainPointCard: React.FC<{icon: string, label: string}> = ({icon, label}) => {
    return (
        <FlexCol 
            gap={1.5} 
            padding={2}
            align="center"
            borderRadius={0.75}
            style={{
                backgroundColor: 'white',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                height: '100%',
            }}
        >
            <img
                src={icon}
                alt={`${label} icon`}
                style={{width: 'auto', height: '70px', objectFit: 'contain'}}
            />
            <Body1 text={label} textAlign="center" fontSize={1.1} />
        </FlexCol>
    )
}
